module.exports = __webpack_public_path__ + "img/play.358a4f6b.svg";